import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../context/authContext";
import { requireAuthNavigate } from "../../../../utils";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
import {
  Box,
  HeadingStyled,
  HeadingStyledLg,
  HeadingStyledSm,
  SpanStyled,
} from "../../../../components/styled/Elements";
import LeadForm from "../lead-form/leadForm";
import { useTranslation } from "react-i18next";
import {
  LookingForWrapper,
  SmBanner,
} from "../../../../components/profile/lookingForBanner/styled";
import {
  Email,
  Phone,
  SearchPropIcon,
} from "../../../../components/styled/AllImages";
import AuthHeader from "../../../../components/auth/AuthHeader/AuthHeader";
import { LayoutWrapper } from "../../../../layout/ProfileLayout";

const LeadContact = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    requireAuthNavigate(
      navigate,
      isAuthenticated,
      `${location.pathname}${location.search}`
    );
  }, [isAuthenticated, navigate, location.pathname, location.search]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <LayoutWrapper>
      <AuthHeader />
      <Box className="content-main">
        <LeadContactFluid>
          {/* <Box className='requirement'>
                <Box className='content-inner'>
                    <Row>
                        <HeadingStyled className='main-heading' size="32px" color='var(--white)'> {t('Share_Property_Requirement')} </HeadingStyled>
                    </Row>
                </Box>

            </Box> */}
          <Box className="heading-container px-5">
            <HeadingStyled
              color="var(--white)"
              size="24px"
              className="mt-3 text-uppercase"
            >
              {t("Share_Property_Requirement")}
            </HeadingStyled>
          </Box>
          <Box className="content-inner flex-wrap">
            {/* <Box className="requirement">
          <Row>
            <Col>
              <HeadingStyled size="24px" color="var(--themeColor)">
                {" "}
                {t("Share_Property_Requirement")}{" "}
              </HeadingStyled>
            </Col>
          </Row>
        </Box> */}
            <Row className="lead-content">
              <Col lg={8} md={12}>
                <Box className="form shadow-lg bg-white px-3 px-md-4 rounded-3">
                  <LeadForm />
                </Box>
              </Col>
              <Col lg={4} md={12}>
                <SmBanner>
                  <Box className="smBannerInner">
                    <LookingForWrapper>
                      <Box className="lookingForContent">
                        <HeadingStyled size="22px" color="var(--white)">
                          {t("Lookingfor")}
                        </HeadingStyled>
                        <Box className="sRHeadingWrapper">
                          <HeadingStyledLg
                            size="40px"
                            className="sRHeading sRHeadingOne"
                          >
                            {t("SubmitRequest")}
                          </HeadingStyledLg>
                          <HeadingStyledLg
                            size="40px"
                            className="sRHeading sRHeadingSec"
                          >
                            {t("SubmitRequest")}
                          </HeadingStyledLg>
                        </Box>
                        <Box>
                          <Box className="d-flex align-items-center gap-1 mt-2">
                            <Email width={24} height={24} fill="var(--white)" />
                            <SpanStyled color="var(--white)">
                              {t("submit_requirements")}
                            </SpanStyled>
                          </Box>
                          <Box className="d-flex align-items-center gap-1 mt-1">
                            <Phone fill="var(--white)" width={24} height={24} />
                            <SpanStyled color="var(--white)">
                              {t("get_brokers_call")}
                            </SpanStyled>
                          </Box>
                        </Box>
                        {/* <HeadingStyledSm
                      size="22px"
                      color="var(--white)"
                      className="fillOut"
                    >
                      {t("Filloutnow")}
                    </HeadingStyledSm> */}
                        <img
                          src={SearchPropIcon}
                          alt="search property icon"
                          className="propertySmBannerIcon"
                        />
                      </Box>
                    </LookingForWrapper>
                  </Box>
                </SmBanner>
                {/* <Box className='design direct-connection'>
                            <Box className='text-center'>
                                <DirectImg />
                            </Box>
                            <HeadingStyled className='my-3 heading-connect' > {t('Connect_directly_with_brokers')} </HeadingStyled>
                            <Box className='d-flex flex-column gap-2'>
                                <TextWithIcon icon={Email} title={t('Submit_your_requirement')} />
                                <TextWithIcon icon={Phone} title={t('Receive_direct')} />
                            </Box>
                        </Box> */}
              </Col>
            </Row>
          </Box>
        </LeadContactFluid>
      </Box>
    </LayoutWrapper>
  );
};

export default LeadContact;

const LeadContactFluid = styled.section`
  margin-top: 0px;

  .heading-container {
    position: absolute;
    /* right: 0; */
    /* left: 0; */
    top: 0;
    z-index: -1;
    height: 150px;
    background-color: var(--themeColor);
    width: 100vw; /* Ensure it spans the entire viewport width */
    left: 50%;
    transform: translateX(-50%);
  }
  .content-inner {
    position: absolute;
    top: 100px;
  }

  & .requirement {
    padding: 20px 0;
    background: var(--DarkText);
  }

  .design {
    background: var(--whiteColor);
    // border: 1px solid gray;
    border-radius: 10px;
    padding: 30px 20px;
    position: relative;
    bottom: 50px;
    box-shadow: 0px 0px 9px 0px rgba(152, 111, 31, 0.2);
    -webkit-box-shadow: 0px 0px 9px 0px rgba(152, 111, 31, 0.2);
    -moz-box-shadow: 0px 0px 9px 0px rgba(152, 111, 31, 0.2);
  }
  // .direct-connection{
  //     position: sticky;
  //     top: 200px;
  // }
`;
